export const getAccountColumns = (translate) => {
  return [
    {
      dataField: 'name',
      text: translate('Name'),
      sort: true,
    },
    {
      dataField: 'services',
      text: translate('Services'),
      sort: true,
    },
    {
      dataField: 'begin',
      text: translate('Begin'),
      sort: true,
    },
    {
      dataField: 'end',
      text: translate('End'),
      sort: true,
    },
    {
      dataField: 'status',
      text: translate('Status'),
      sort: true,
    },
    {
      dataField: 'action',
      text: translate('Action'),
      sort: true,
    },
  ];
};
